import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    > form {
        height: 100%;
    }
    overflow:auto;
}
`;

export const DeleteButtonArea = styled.div`
margin-left: 5px;
}
`;

export const AddButtonArea = styled.div`
margin-top: 10px;
}
`;

export const SubmitButtonArea = styled.div`
width: 100%;
margin-top: 10px;
> button {
   width:100%;
}
}
`;

export const ActionArea = styled.div`
    display: flex;
    right: 10px;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
`;

export const FormArea = styled.div`
flex: 1 1 auto;
overflow-y: auto;
min-height: 0px;
margin-top: 10px;
    padding: 10px;
    overflow-y: scroll;
    padding: 0px 10px 10px 10px;
    > button {
        margin-right: 10px;
     }
}
`;

export const DeleteIntentButtonArea = styled.div`
        margin-right: 10px;
}
`;

export const IndexNumber = styled.div`
> span {
    height: 100%;
min-height: 0px;
display: inline-flex;
align-items: center;
}
}
`;

export const TitleArea = styled.div`
position: absolute;
top: 50%;
-ms-transform: translateY(-50%);
transform: translateY(-50%);
    width: 400px;
    display: flex;
    > input {
        width: 200px;
        height:40px;
        margin-right: 10px;
    }
}
`;
